const debugSettings = {
  /** 테스트용 상품 가져오는지 여부.
   * @default: false
   *  **/
  isGetTestProduct: false,
  /** 결제시 IAMPORT의 WebHook을 받을 것인지 */
  isSendLocalNotice: false,

  /** 모바일 디버깅을 위해 임시 ip주소 사용
   * @default: false
   *  **/
  isMobileApiUrl: false,

  /** 로컬 환경에서 테스트 PG MID 사용 여부
   * @default: true (테스트 MID 사용)
   * true: html5_inicis.INIBillTst (테스트)
   * false: html5_inicis.MOI9209600 (실연동)
   *  **/
  isUseTestPg: false,
};

export default class GlobalEnvironments {
  public static PRODUCTION: boolean =
    process.env.REACT_APP_DOMAIN !== "localhost";

  public static getIsGetTestProduct = () => {
    if (GlobalEnvironments.PRODUCTION) {
      return false;
    } else {
      return debugSettings.isGetTestProduct;
    }
  };
  public static getIsSendLocalNotice = () => {
    if (GlobalEnvironments.PRODUCTION) {
      return false;
    } else {
      return debugSettings.isSendLocalNotice;
    }
  };
  public static getApiUrl = () => {
    if (GlobalEnvironments.PRODUCTION || !debugSettings.isMobileApiUrl) {
      return process.env.REACT_APP_API_URL;
    } else {
      return "http://192.168.219.145:8000/";
    }
  };
  public static getDomainUrl = () => {
    if (GlobalEnvironments.PRODUCTION || !debugSettings.isMobileApiUrl) {
      return process.env.REACT_APP_DOMAIN;
    } else {
      return "192.168.219.145";
    }
  };
  public static getAppUrl = () => {
    if (GlobalEnvironments.PRODUCTION || !debugSettings.isMobileApiUrl) {
      return process.env.REACT_APP_URL;
    } else {
      return "http://192.168.219.106:3000/";
    }
  };
  public static getPgProvider = () => {
    if (GlobalEnvironments.PRODUCTION) {
      return "tosspayments.im_ddusulxhio";
    } else {
      if (debugSettings.isUseTestPg) {
        return "tosspayments.iamporttest_3";
      } else {
        return "tosspayments.im_ddusulxhio";
      }
    }
  };

  /** 계좌이체/무통장입금용 PG Provider 반환 */
  public static getTransferPgProvider = () => {
    if (GlobalEnvironments.PRODUCTION) {
      return "tosspayments.im_ddusul8bvu";
    } else {
      if (debugSettings.isUseTestPg) {
        return "tosspayments.iamporttest_3";
      } else {
        return "tosspayments.im_ddusul8bvu";
      }
    }
  };

  /** 정기결제(구독)용 PG Provider 반환 */
  public static getSubscriptionPgProvider = () => {
    if (GlobalEnvironments.PRODUCTION) {
      return "tosspayments.bill_im_dd7a7z";
    } else {
      if (debugSettings.isUseTestPg) {
        return "tosspayments.iamporttest_4";
      } else {
        return "tosspayments.bill_im_dd7a7z";
      }
    }
  };
}
